APP.AsyncModule = (/** @lends APP.AsyncModule */function () {
	'use strict';

	var exports = {},
		request = {},
		results = {},
		inited = false,
		$body = false;

	function init() {
		initDOMElements();
		initRequestHandlers();
		inited = true;
	}

	function initDOMElements() {
		if (!$body) {
			$body = APP.Performance.getCachedDOM().$body;
		}
	}

	function initRequestHandlers() {
		$body.find('[data-async-request]:not([data-async-request-initialized])').each(function () {
			var $this = $(this),
				requestId = $this.attr('data-async-request'),
				url = $this.attr('data-async-request-url'),
				type = $this.attr('data-async-request-type') || 'post',
				data = window.parseJSON($this.attr('data-async-request-data'));

			$this.attr('data-async-request-initialized', true);
			bindRequest(requestId, url, data, type);

		});

		$body.find('[data-async-module]:not([data-async-module-initialized])').each(function () {
			var $this = $(this),
				requestId = $this.attr('data-async-module'),
				hbsTemplate = $this.attr('data-async-module-hbs'),
				finishCb = $this.attr('data-async-finish-cb'),
				moduleName = $this.attr('data-async-module-name') || '';

			moduleName = moduleName.split(';');
			$this.attr('data-async-module-initialized', true);
			requestSubscribe($this, requestId, hbsTemplate, moduleName, finishCb);

		});

		if (inited === false) {

			$body.on({
				change: function (e) {
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();
					refreshRequest($(this));
				}
			}, '[data-async-refresh][data-async-refresh-event="change"]');

			$body.on({
				click: function () {
					refreshRequest($(this));
				}
			}, '[data-async-refresh][data-async-refresh-event="click"]');

		}

	}

	function onRequest(requestId, callback) {
		$body.on('request-' + requestId, function () {
			callback(results[requestId]);
		});
	}

	function requestSubscribe($element, requestId, hbsTemplate, moduleName, finishCb) {
		var tpl = APP.Template.get(hbsTemplate),
			loaded = true,
			callbackRaw,
			callbackFn,
			callbackParams = [],
			i;

		onRequest(requestId, function (result) {
			loaded = true;

			for (i = 0; i < moduleName.length; i++) {
				if (result.data.async && result.data.async.unFilled && result.data.async.unFilled.hasOwnProperty(moduleName[i])) {
					loaded = false;
					break;
				}
			}

			if (loaded && $element.attr('data-async-content-status') !== 'loaded') {

				$element.attr('data-async-content-status', 'loaded');
				$element.html(tpl(result));
				APP.Tooltip.reposition();
				APP.Main.init();

				if (moduleName && moduleName[0] === 'privacySettings') {
					APP.Settings.saveOriginalPrivacy();
				}

				if (finishCb) {
					callbackRaw = finishCb.split(':');
					if (callbackRaw.length > 0) {
						callbackFn = callbackRaw[0];
						if (callbackRaw[1] !== undefined) {
							callbackParams = callbackRaw[1].split(',');
						}

						if (callbackParams[0] === 'patchResult') {
							callbackParams[0] = result;
						}

						if (doesFunctionExists(callbackFn)) {
							executeFunctionByName(callbackFn, window, callbackParams);
						}
					}

				}

			}

		});

		triggerRequestIfExist(requestId);

	}

	function executeFunctionByName(functionName, rawContext, args) {
		var context = rawContext,
			ns = functionName.split('.'),
			func = ns.pop(),
			i = 0;

		for (i; i < ns.length; i++) {
			context = context[ns[i]];
		}

		return context[func].apply(this, args);
	}

	function doesFunctionExists(namespace) {
		var tokens = namespace.split('.');

		return tokens.reduce(function (prev, curr) {
			return typeof prev === 'undefined' ? prev : prev[curr];
		}, window);
	}

	function triggerRequestIfExist(requestId) {
		if (typeof results[requestId] === 'object') {
			$body.trigger('request-' + requestId);
		}
	}

	function bindRequest(requestId, url, data, type) {
		request[requestId] = APP.Service[type](data, url)
			.done(function (response) {
				results[requestId] = response;
				$body.trigger('request-' + requestId);

				if (response.data.async !== undefined && response.data.async.wait) {
					repeatRequest(requestId, url, data, type, response.data.async.wait * 1000);
				}

			})
			.fail(function () {
				repeatRequest(requestId, url, data, type, 1000);
			});

	}

	function repeatRequest(requestId, url, data, type, timeout) {
		window.setTimeout(function () {
			bindRequest(requestId, url, data, type);
		}, timeout);
	}

	function refreshRequest($elem) {
		var $this = $elem,
			loaderTpl = APP.Template.get('loader'),
			requestId = $this.attr('data-async-refresh'),
			$module = $body.find('[data-async-module="' + requestId + '"]'),
			$request = $body.find('[data-async-request="' + requestId + '"]'),
			$paramsObj = $module.find('[data-async-refresh-params]'),
			selfTrigger = false,
			selfTriggerKey = '',
			url, type, data = {};

		if ($elem.attr('data-async-refresh-values') && $elem.attr('data-async-refresh-values') === 'dom|self') {
			selfTrigger = true;
			selfTriggerKey = $elem.attr('data-async-refresh-params');
		}

		$.each($paramsObj, function () {
			var params = $(this).attr('data-async-refresh-params').split(':'),
				valueSources = $(this).attr('data-async-refresh-values').split(':');

			if (valueSources && params) {

				$.each(valueSources, function (key, val) {
					var conditional = val.split('|')[1] || 'val',
						$obj = getRefreshObj(params, key, $module);

					switch (conditional) {
					case 'checked':
						data[params[key]] = $obj.prop('checked') === true ? 1 : 0;
						break;
					case 'value':
						data[params[key]] = $obj.val();
						break;
					case 'data-val':
						if (key !== selfTriggerKey && selfTrigger !== true) {
							data[params[key]] = $obj.attr('data-async-refresh-val');
						}
						break;
					case 'self':
						if (selfTrigger === true) {
							data[selfTriggerKey] = $elem.attr('data-async-refresh-val');
						}
						break;
					default:
						break;
					}

				});

			}

		});

		if ($request.length > 0) {
			$module.attr('data-async-content-status', '');
			url = $request.attr('data-async-request-url');
			type = $request.attr('data-async-request-type') || 'post';
			$module.html(loaderTpl({}));
			bindRequest(requestId, url, data, type);
		}

	}

	function getRefreshObj(params, key, $module) {
		var $obj;

		$obj = $module.find('[name="' + params[key] + '"]');

		if ($obj.length < 1) {
			$obj = $module.find('#' + params[key]);
		}

		if ($obj.length < 1) {
			$obj = $module.find('[data-async-param-id="' + params[key] + '"]');
		}

		return $obj;
	}

	exports.init = init;
	exports.onRequest = onRequest;
	exports.initRequestHandlers = initRequestHandlers;
	return exports;

}());
